/* eslint-disable consistent-return */
/* eslint-disable global-require */
import getDeviceHelpers from '../helpers/deviceHelpers';

const getDefaultAudioInputDevice = devices => devices.find(device => device.deviceId === 'default');

export default (deps = {}) => {
  const { getAudioInputMediaDevices } = deps.deviceHelpers || getDeviceHelpers();

  let lastDefaultDevice = null;
  getAudioInputMediaDevices().then((devices) => {
    lastDefaultDevice = getDefaultAudioInputDevice(devices);
  });

  const audioInputDevicesChangeHandler = async (currentAudioSource) => {
    const devices = await getAudioInputMediaDevices();

    // If there are no devices, let's store an empty value.
    if (devices.length === 0) {
      lastDefaultDevice = null;
      return;
    }
    // If default device is a new one, return it.
    const defaultDevice = getDefaultAudioInputDevice(devices);
    if (defaultDevice) {
      if (lastDefaultDevice?.label !== defaultDevice.label) {
        lastDefaultDevice = defaultDevice;
        return defaultDevice;
      }
    } else {
      lastDefaultDevice = null;
    }
    const currentDeviceId =
      currentAudioSource?.getConstraints && currentAudioSource?.getSettings?.()?.deviceId;
    if (currentDeviceId) {
      const currentDevice = devices.find(
        ({ deviceId }) => deviceId === currentDeviceId
      );
      if (currentDevice && currentDevice.label === currentAudioSource.label) {
        return;
      }
    }
    // Since the current output device was removed, let's use the default device or the first one.
    return defaultDevice || devices[0];
  };

  return audioInputDevicesChangeHandler;
};
